import Cookies from "js-cookie";

/**
 * Met à jour les données pour une instance spécifique.
 * @param {string} token Le token d'authentification
 * @param {string} instanceId L'ID de l'instance à mettre à jour
 * @param {Object} updateData Les données à mettre à jour
 * @returns {Promise<Object>} Le résultat de l'appel d'API
*/
export async function docUpdate(token,InstanceId, DocumentId, sComplexite, prio, isValid,status) {
  const api_url = Cookies.get("ApiUrl");
  const url = `${api_url}/document/update`;
  try {
    const response = await fetch(url, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify(
        {
            "DocumentId" : DocumentId,
            "InstanceId" : InstanceId,            
            "FieldList" : {
                "sComplexite" : sComplexite,
                "bValid" : isValid,
                "dPriorite" : prio,
                "sStatus":status
            
        }
    }),
    });

    if (!response.ok) {
      alert('Mise à jour échoué pour le doc' + DocumentId )
      throw new Error(`Erreur API: ${response.status} ${response.statusText}`);
    }

    return await response.json(); // Ou retourner une valeur spécifique selon les besoins
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'instance:", error);
    throw error; // Rethrow l'erreur pour la gestion d'erreur en amont
  }
}

/**
 * Met à jour le status du document à partir de son id
 */
export async function updateDocumentStatus(token, InstanceId, DocumentId, status, klippaSessionId) {
  const api_url = Cookies.get("ApiUrl");
  const url = `${api_url}/document/update`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify({
        "DocumentId": DocumentId,
        "InstanceId": InstanceId,
        "FieldList": {
          "sStatus": status,
          "sKlippaSessionId": klippaSessionId   
        }
      }),
    });

    if (!response.ok) {
      alert(' Mise à jour échouée pour le document ' + DocumentId);
      throw new Error(`Erreur API: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Erreur lors de la mise à jour du document:", error);
    throw error;
  }
}
